module.exports = __webpack_public_path__ + "img/art-statement.9c719a8b.jpeg";